'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

var Switch = React.createClass({

  propTypes: {
    isOpen: React.PropTypes.bool.isRequired
  },
  getInitialState: function () {
    return {
      isOpen: this.props.isOpen,
      opacity: 1
    }
  },

  componentWillReceiveProps: function (newProps) {
    if (newProps.isOpen !== this.props.isOpen)
      this.setState({isOpen: _.isUndefined(newProps.switchStatus) ? newProps.isOpen : (parseInt(newProps.switchStatus, 10) === -1)})
  },

  render: function () {
    var isOpen = styleHelper.getStateProperty(this.props, propConst.IS_OPEN);
    var borderColor = styleHelper.getBorderColor(this.props);
    var onColor = styleHelper.getPropertyValue(this.props, propConst.OPEN_COLOR);
    /*getPropertyValue考虑交互*/
    var offColor = styleHelper.getPropertyValue(this.props, propConst.CLOSE_COLOR);
    var backgroundColor = styleHelper.getPropertyValue(this.props, propConst.BACKGROUND_COLOR);
    var offBackgroundColor, onBackgroundColor;
    var onStyle = {}, offStyle = {};
    var borderVisible = this.props.borderVisible;

    if (_.isUndefined(isOpen)) {
      isOpen = this.state.isOpen;
    }
    if (onColor) {
      onStyle.backgroundColor = isOpen ? onColor : backgroundColor;
      /*onStyle.borderLeft = this.props.borderColor ? '1px solid ' + this.props.borderColor : '1px solid ' + onColor;*/
      onStyle.boxSizing = 'border-box';
    } else {
      offStyle.backgroundColor = isOpen ? '#ddd' : '#c1c1c1';
      /*onStyle.borderRight = this.props.borderColor ? '1px solid ' + this.props.borderColor : '1px solid ' + onColor;*/
      offStyle.display = isOpen ? 'none' : 'block';
    }
    if (offColor) {
      offStyle.backgroundColor = isOpen ? backgroundColor : offColor;
      offStyle.display = isOpen ? 'none' : 'block';
    } else {
      onStyle.backgroundColor = isOpen ? '#41cdd6' : '#ddd';
    }
    if (borderColor === 'rgba(0,0,0,0)') {
      borderColor = 'rgba(102,102,102,1)';
    }
    var dom =
      <div className="component contents-layout border"
           style={{
             lineHeight: (this.props.h - 2) + 'px',
             borderColor: borderVisible ? borderColor : 'inherit'
           }}
           onClick={this.onClick}>
        <div className="off" style={offStyle}>
          <label style={{
            display: isOpen ? 'none' : 'block'
          }}>
            OFF
          </label>
        </div>
        <div className="on" style={onStyle}>
          <label style={{
            display: isOpen ? 'block' : 'none'
          }}>
            ON
          </label>
        </div>
      </div>;
    return ( dom );
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onClick);
  },

  //此事件由jquery触发，没有pageX等点击数据
  //这里在trigger的时候把原来的事件传下来，而不使用trigger产生的事件
  onClick: function (e, index, linkKey, evt) {
    var isOpen = !this.state.isOpen;
    if (isOpen) {
      this.props.events.switchOn(evt, this.props, 'interactive-link', 0);
    } else {
      this.props.events.switchOff(evt, this.props, 'interactive-link', 0);
    }

    this.setState({
      isOpen: isOpen
    });
  }
});


module.exports = Switch;



// WEBPACK FOOTER //
// ./src/views/Components/Switch.jsx